import {Tag, TagByIdFunction} from "@web-libs/core/tags/api/tags.types";


export const AllInstitutionsTag:Tag = {
    value: 'institutions',
    appendTenantId: true
}

export const getInstitutionTag: TagByIdFunction = (id: string): Tag => {
    return {
        value: 'institutions',
        id: id,
    }
}
